import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { API_BASE, api, auth } from '../api';
import { run, useToast } from '../hooks';

/** Console sign-in (FR-C-01). Users get their first password through the link in the ready email (D-23). */
export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation() as { state?: { email?: string; notice?: string } };
  const { toast, show } = useToast();
  const [email, setEmail] = useState(location.state?.email ?? '');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [token, setToken] = useState(auth.token ?? '');

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    const r = await run(api.login(email.trim(), password), show);
    setBusy(false);
    if (r) navigate('/sites');
  }

  return (
    <div style={{ maxWidth: 440 }}>
      <h1>Sign in</h1>
      {location.state?.notice && <p className="badge ok" style={{ marginTop: 12 }}>{location.state.notice}</p>}
      <form className="card grid" style={{ gap: 12, marginTop: 20 }} onSubmit={submit}>
        <label className="field">
          Email
          <input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="field">
          Password
          <input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        <div className="row spread">
          <button className="btn primary" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
          <Link to="/forgot-password" className="small muted">
            Forgot password?
          </Link>
        </div>
        <p className="small muted">Your first password is set through the link in the email you receive when your scan is ready.</p>
      </form>

      <details className="card" style={{ marginTop: 16 }}>
        <summary className="small muted" style={{ cursor: 'pointer' }}>
          Operator access (token)
        </summary>
        <p className="muted small" style={{ marginTop: 10 }}>
          For the owner and local development against <span className="mono">{API_BASE || 'this host'}</span>. Grants access to every site.
        </p>
        <div className="row" style={{ marginTop: 10 }}>
          <input className="input" value={token} onChange={(e) => setToken(e.target.value)} placeholder="SB_ADMIN_TOKEN" />
          <button
            type="button"
            className="btn"
            onClick={() => {
              auth.token = token.trim() || null;
              if (auth.token) navigate('/sites');
            }}
          >
            Use token
          </button>
        </div>
      </details>
      {toast && <div className={`toast${toast.err ? ' err' : ''}`}>{toast.text}</div>}
    </div>
  );
}
